"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/exports/StyleSheet"));

var _styles = require("quark-core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// external imports
// local imports
var _default = _StyleSheet.default.create({
  reset: {
    margin: 0
  },
  h1: {
    marginBottom: 4 * _styles.baseDim
  },
  h2: {
    marginBottom: 3 * _styles.baseDim
  },
  h3: {
    marginBottom: 2 * _styles.baseDim
  },
  title: {},
  subtitle: {},
  text: {},
  link: {},
  monospace: {}
});

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/typography/styles.js
// module id = ./node_modules/quark-core/components/typography/styles.js
// module chunks = 0